// extracted by mini-css-extract-plugin
export default {"root":"NewsItem_root__gRC+e","icon":"NewsItem_icon__XfVnQ","title":"NewsItem_title__D-1d+","text":"NewsItem_text__-dCbZ","date":"NewsItem_date__OamEV"};